export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-book-open-line',
      title: 'Giáo trình chuẩn STEAM',
      description: 'Chương trình đào tạo được thiết kế theo tiêu chuẩn STEAM quốc tế, kết hợp lý thuyết và thực hành, phát triển tư duy sáng tạo và giải quyết vấn đề cho học viên',
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Học qua dự án thực tế',
      description: 'Phương pháp Project-Based Learning giúp học viên áp dụng kiến thức vào các dự án robot thực tế, từ cơ bản đến nâng cao, phát triển kỹ năng làm việc nhóm',
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Giảng viên & Mentor chuyên nghiệp',
      description: 'Đội ngũ giảng viên có trình độ chuyên môn cao, bao gồm Kỹ sư và Thạc sỹ với kinh nghiệm thực chiến, mentor 1-1 hỗ trợ học viên trong suốt quá trình học tập và phát triển dự án cá nhân',
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-flask-line',
      title: 'Phòng Lab hiện đại',
      description: 'Trang thiết bị phòng thí nghiệm đầy đủ với robot arms, drone, IoT devices, AI computing platforms, tạo môi trường học tập thực tế và chuyên nghiệp nhất',
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-medal-line',
      title: 'Chứng nhận quốc tế',
      description: 'Học viên nhận chứng chỉ hoàn thành khóa học có giá trị sử dụng trên toàn quốc, khẳng định năng lực và kiến thức đã đạt được trong lĩnh vực Robotics và AI',
      gradient: 'from-orange-500 to-orange-600'
    },
    {
      icon: 'ri-tools-line',
      title: 'Hỗ trợ thiết bị học tập',
      description: 'Cung cấp đầy đủ robotics kit, linh kiện điện tử, phần mềm lập trình trong suốt khóa học, học viên có thể mang về nhà để thực hành và phát triển thêm',
      gradient: 'from-orange-500 to-orange-600'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-orange-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Tại sao chọn <span className="text-orange-600">ESAPCOR</span>?</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">Chúng tôi cam kết mang đến chương trình đào tạo Robotics và AI chất lượng cao nhất với đầy đủ trang thiết bị, giáo trình chuẩn quốc tế và đội ngũ giảng viên chuyên nghiệp</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-orange-200 group"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}